/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';
import type { PayType } from './PayType';
import {
    PayTypeFromJSON,
    PayTypeFromJSONTyped,
    PayTypeToJSON,
    PayTypeToJSONTyped,
} from './PayType';

/**
 * 
 * @export
 * @interface ListPayTypesResponse
 */
export interface ListPayTypesResponse {
    /**
     * 
     * @type {Array<PayType>}
     * @memberof ListPayTypesResponse
     */
    data: Array<PayType>;
    /**
     * 
     * @type {Pagination}
     * @memberof ListPayTypesResponse
     */
    pagination: Pagination;
}

/**
 * Check if a given object implements the ListPayTypesResponse interface.
 */
export function instanceOfListPayTypesResponse(value: object): value is ListPayTypesResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function ListPayTypesResponseFromJSON(json: any): ListPayTypesResponse {
    return ListPayTypesResponseFromJSONTyped(json, false);
}

export function ListPayTypesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListPayTypesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(PayTypeFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

  export function ListPayTypesResponseToJSON(json: any): ListPayTypesResponse {
      return ListPayTypesResponseToJSONTyped(json, false);
  }

  export function ListPayTypesResponseToJSONTyped(value?: ListPayTypesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(PayTypeToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
    };
}

